<template>
  <div class="helpAdd">
    <div class="helpAdd-form">
      <div>
        <div>人工客服</div>
        <div class="helpAdd-kf">
          <img :src="require(`@/assets/test.png`)" alt="">
          <div>杨老师</div>
          <div>0371-86082035</div>
        </div>
      </div>
      <div>提交问题</div>
      <el-form
        ref="info"
        :model="info"
        :rules="standardInfo.obj.rules"
        status-icon
        label-position="left"
        label-width="0px"
      >
        <el-form-item prop="title" label="标题">
          <el-input
            v-model="info.title"
            type="text"
            auto-complete="off"
            placeholder="请输入需求名称主题"
            clearable
          />
        </el-form-item>
        <el-form-item prop="info" label="问题描述">
          <el-input
            v-model="info.info"
            type="textarea"
            :rows="6"
            auto-complete="off"
            placeholder="请输入需求信息内容"
            clearable
          />
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary" class="btn1" @click="handleSubmit"
          >
            提交
          </el-button
          >
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import api from '@/api/app'
import mock from '@/utils/mock'
export default {
  components: {},
  data() {
    return {
      standardInfo: mock.notes.standard.viewInfo,
      standardInit: mock.notes.standard.init,
      info: {
        phone: '',
        code: '',
        type: 2
      },
      loading: false
    }
  },
  computed: {},
  created() {},
  mounted() {},
  methods: {
    handleSubmit() {
      this.$refs.info.validate((valid) => {
        if (valid) {
          this.$confirm('确认提交个性定制吗?', '提示', {})
            .then(() => {
              api.proList.create.add(this.info).then(() => {
                this.$message({
                  message: '个性定制提交成功',
                  type: 'success'
                })
              })
            })
            .catch(() => {})
        }
      })
    },
    control(type, condition) {
      return mock.system.global.control[type](condition)
    }
  }
}
</script>
<style lang="scss" scoped>
.helpAdd {
  @include fun-layout(1);
  width: 66%;
  margin: 0 auto;
  &-kf {
    text-align: center;
    margin: 40px 0;
    > img {
      height: 150px;
      width: 150px;
    }
    > div{
      margin-top: 5px;
    }
  }
  &-form {
    height: 100%;
    background-color: #fff;
    padding-top: 25px;
    border-radius: 10px;
    padding-bottom: 50px;
    > div {
      &:nth-child(1) {
        > div {
          &:nth-child(1) {
            padding-bottom: 15px;
            padding-left: 40px;
            font-size: 14px;
            @include fun-design(4);
            font-weight: bold;
          }
        }
      }
      &:nth-child(2) {
        padding-top: 50px;
        margin-left: 40px;
        margin-right: 40px;
        @include fun-border(0, "top");
        font-size: 14px;
        @include fun-design(4);
        font-weight: bold;
      }
    }
    > form {
      padding: 40px 40px 0 40px;
      > div {
        text-align: left;
      }
      button {
        width: 150px;
        &:nth-child(1) {
          background-color: #2f82ff;
          border: 0;
        }
      }
    }
  }
}
</style>

<style scoped lang="scss">
.helpAdd-form /deep/.el-form-item {
  margin-bottom: 30px;
}
.helpAdd-form /deep/ .el-input__inner {
  -webkit-appearance: none;
  background-color: #fff;
  background-image: none;
  border-radius: 0;
  width: 100%;
  height: 45px;
}
.helpAdd-form /deep/ .el-form-item__label {
  width: 200px !important;
}
.helpAdd-form /deep/ .el-input__suffix{
  top: 23%;
}
.helpAdd-form /deep/ .el-input{
  display: block;
  width: 45%;
}
.helpAdd-form /deep/ .el-textarea{
  width: 70%;
  display: block;
}
.helpAdd-form /deep/ .el-textarea__inner{
  border-radius: 0px;
}
</style>
